export default "__VITE_ASSET__DOKRm3Gf__"